import { api } from "./useApi";

export interface AquecimentoData {
  ativo: boolean;
  dia_atual: number;
  limite_atual: number;
  enviados_hoje: number;
  data_inicio: string | null;
}

export interface HistoricoRegistro {
  id: number;
  canal: string;
  evento: string;
  destinatario: string;
  referencia_tipo: string;
  referencia_id: number;
  status: number;
  data_criacao: string;
  data_envio: string | null;
}

export interface HistoricoResponse {
  registros: HistoricoRegistro[];
  total: number;
  pagina: number;
  por_pagina: number;
  total_paginas: number;
}

export interface ConexaoStatus {
  conectado: boolean;
  status: string;
  numero: string | null;
  nome: string | null;
}

export interface ConectarResponse {
  status: string;
  qr_code: string | null;
}

export const mensageriaApi = () => ({
  salvarConfiguracaoMensageria: async (mensageria: any) => {
    try {
      const response = await api.post("mensageria/configurar", {
        comunicacao: mensageria,
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao salvar configuracao de mensageria", error);
      return null;
    }
  },

  conectarWhatsApp: async (): Promise<ConectarResponse | null> => {
    try {
      const response = await api.post("mensageria/conectar", {});
      return response.data;
    } catch (error) {
      console.error("Erro ao conectar WhatsApp", error);
      return null;
    }
  },

  verificarStatus: async (): Promise<ConexaoStatus | null> => {
    try {
      const response = await api.post("mensageria/status", {});
      return response.data;
    } catch (error) {
      console.error("Erro ao verificar status", error);
      return null;
    }
  },

  desconectarWhatsApp: async () => {
    try {
      const response = await api.post("mensageria/desconectar", {});
      return response.data;
    } catch (error) {
      console.error("Erro ao desconectar WhatsApp", error);
      return null;
    }
  },

  buscarAquecimento: async (): Promise<AquecimentoData | null> => {
    try {
      const response = await api.post("mensageria/aquecimento", {});
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar aquecimento", error);
      return null;
    }
  },

  testarEnvio: async () => {
    try {
      const response = await api.post("mensageria/testar_envio", {});
      return response.data;
    } catch (error) {
      console.error("Erro ao testar envio", error);
      return null;
    }
  },

  buscarHistorico: async (
    pagina: number = 1,
    filtros?: { evento?: string; canal?: string }
  ): Promise<HistoricoResponse | null> => {
    try {
      const response = await api.post("mensageria/historico", {
        pagina,
        ...filtros,
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar historico", error);
      return null;
    }
  },
});
